import React from "react";
import Home from "./Home";

const languageDataKeys = {
  mn: "Mongolian",
  en: "English",
  ko: "Korean",
  jp: "Japanese",
  de: "German",
  se: "Swedish",
  fr: "French",
  es: "Spanish",
  ru: "Russian",
  zh: "Chinese",
  tr: "Turkish", 
  kz: "Kazakh",
  uz: "Uzbek",
  az: "Azerbaijani",
  tj: "Tajik",
  kg: "Kyrgyz",
  tm: "Turkmen",
  ar: "Arabic",
};

const deepMerge = (base, override = {}) => {
  if (!base || typeof base !== "object" || Array.isArray(base)) {
    return override === undefined ? base : override;
  }

  return Object.keys(base).reduce(
    (merged, key) => ({
      ...merged,
      [key]: deepMerge(base[key], override[key]),
    }),
    { ...override }
  );
};

export const Main = ({ data, language }) => {
  const getLanguageData = (lang) => {
    const languageKey = languageDataKeys[lang] || languageDataKeys.mn;
    const languageData = data[languageKey] || {};

    return languageKey === "English"
      ? data.English
      : deepMerge(data.English, languageData);
  };

  const langData = getLanguageData(language);

  return <Home data={langData.Home} />;
};
